export default __webpack_public_path__ + "media/images/brands/jo-malone-036e60649306809bffdb22f441d6b299.png";